import * as React from 'react';
export var IconRectangleAngled = React.forwardRef(function IconRectangleAngled({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M2.296 2.743a1.75 1.75 0 0 0-1.237 2.143l1.682 6.279a1.75 1.75 0 0 0 2.143 1.237L5 12.37v.88c0 .966.783 1.75 1.75 1.75h6.5A1.75 1.75 0 0 0 15 13.25v-6.5A1.75 1.75 0 0 0 13.25 5h-1.808l-.724-2.703A1.75 1.75 0 0 0 8.574 1.06L2.296 2.743ZM9.889 5l-.62-2.314a.25.25 0 0 0-.306-.177L2.684 4.192a.25.25 0 0 0-.177.306l1.683 6.278a.25.25 0 0 0 .306.177L5 10.818V6.75C5 5.784 5.783 5 6.75 5h3.139ZM6.5 6.75a.25.25 0 0 1 .25-.25h6.5a.25.25 0 0 1 .25.25v6.5a.25.25 0 0 1-.25.25h-6.5a.25.25 0 0 1-.25-.25v-6.5Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M5.037 5.034a2.75 2.75 0 0 0-1.945 3.368l1.941 7.245A2.75 2.75 0 0 0 8 17.668v.582A2.75 2.75 0 0 0 10.75 21h7.5A2.75 2.75 0 0 0 21 18.25v-7.5A2.75 2.75 0 0 0 18.25 8h-1.806l-.794-2.963a2.75 2.75 0 0 0-3.368-1.944L5.037 5.034ZM14.89 8l-.69-2.574a1.25 1.25 0 0 0-1.531-.884L5.425 6.483a1.25 1.25 0 0 0-.884 1.531l1.941 7.245A1.25 1.25 0 0 0 8 16.146V10.75A2.75 2.75 0 0 1 10.75 8h4.141ZM9.5 10.75c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-7.5c-.69 0-1.25-.56-1.25-1.25v-7.5Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            d: 'M5.037 5.034a2.75 2.75 0 0 0-1.945 3.368l1.941 7.245A2.75 2.75 0 0 0 8 17.668v.582A2.75 2.75 0 0 0 10.75 21h7.5A2.75 2.75 0 0 0 21 18.25v-7.5A2.75 2.75 0 0 0 18.25 8h-1.806l-.794-2.963a2.75 2.75 0 0 0-3.368-1.944L5.037 5.034ZM14.89 8l-.69-2.574a1.25 1.25 0 0 0-1.531-.884L5.425 6.483a1.25 1.25 0 0 0-.884 1.531l1.941 7.245A1.25 1.25 0 0 0 8 16.146V10.75A2.75 2.75 0 0 1 10.75 8h4.141ZM9.5 10.75c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25h-7.5c-.69 0-1.25-.56-1.25-1.25v-7.5Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
